import {NavItem} from '../../models/nav-item.model';

export abstract class NavFactory {
    protected static items?: any[];

    static get(code: any, props = {}): NavItem {
        const navItem = this.items.find(item => item.code === code);
        return navItem ? new NavItem({...navItem, ...props}) : undefined;
    }

    static getAll(): NavItem[] {
        return this.items.map(item => new NavItem(item));
    }
}
